import { BlockModel } from '../../model/block/block.model';
import { IBuildingBlock } from '../../interface/block/building-block.interface';
import { getBlockByType } from '../../enum/block/block-by-type.enum';
import { invariant } from '../debug/invariant.util';
import { AppStateModel } from '../../model/app-state.model';

export const isBlockDragDisabled = (currentPageBlocks: BlockModel[], block: IBuildingBlock, state: AppStateModel) => {
  const blockModel = getBlockByType(block.blockType);
  invariant(Boolean(blockModel._availableBlocks), 'Invalid block model', blockModel);
  // disable blocks based on settings (decorators)
  if (state.activeDesign.data && blockModel._availableBlocks.indexOf(state.activeDesign.data.type) === -1) {
    return true;
  }
  // disable custom list block if advanced content use is off
  const currentBlockModel = getBlockByType(block.blockType);
  if (currentBlockModel.blockAuthorization && !currentBlockModel.blockAuthorization(state)) {
    return true;
  }
  const blocksOfType = currentPageBlocks.filter((activePageBlock) =>
    activePageBlock.blockType === blockModel.blockType);
  const limit = blockModel.blockLimit;
  if (blocksOfType.length === 0 || limit === undefined) {
    return false;
  }
  return blocksOfType.length >= limit;
};
